import React, {useEffect, useState} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {Col, Input, Radio} from 'antd'
import {EEntranceOption} from '../../screens/tracking/type'
import {GetDeliveryInfoResponse} from '../../../api/apiTypes'

type Props = {
    info?: GetDeliveryInfoResponse
    entranceCode?: string
    isNight?: boolean
    onEntranceOptionChange: (entranceOption: EEntranceOption) => void
    onEntrancePasswordChange: (entrancePassword: string) => void
}
const EntranceForm = ({isNight, info, onEntranceOptionChange, onEntrancePasswordChange}: Props) => {
    const {t} = useTranslation(['location'])
    const [entrance, setEntrance] = useState<EEntranceOption>(info?.entrance_option || (isNight? EEntranceOption.GATECODE : EEntranceOption.FREE))
    const [entranceCode, setEntranceCode] = useState(info?.entrance_password)

    useEffect(() => {
        if (info) {
            if (info.entrance_option && info.entrance_option in EEntranceOption) {
                setEntrance(info?.entrance_option)
            }
            if (info.entrance_password) {
                setEntranceCode(info?.entrance_password)
            }
        }
    }, [info])

    useEffect(() => {
        onEntranceOptionChange(entrance)
    }, [entrance])

    useEffect(() => {
        entranceCode && onEntrancePasswordChange(entranceCode)
    }, [entranceCode])

    return (
        <Col style={{width: '100%'}}>
            <div className={'group-title'}>{t('loc.entry.title')}</div>
            <div className={'round-cntr column'}>
                <div className={'delivery-method-inner'}>
                    <Radio.Group className={'column'} onChange={e => setEntrance(e.target.value)} value={entrance}>
                        <div className={"radio-item col"}>
                            <Radio className={'body2'} data-cy={'radioGate'} value={EEntranceOption.GATECODE}>
                                <Trans i18nKey={'GATECODE'} ns={'location'}
                                       components={{blue: <span className={'primary'}/>}}/>
                            </Radio>
                            <Col>
                                {isNight && <div className={'small label black45'} data-cy={'radioGate'}>
                                    {t('entrance.gatecode.label')}
                                </div>}
                                {entrance === EEntranceOption.GATECODE && (
                                    <Input
                                        value={entranceCode}
                                        maxLength={20}
                                        autoComplete={'off'}
                                        size={'middle'}
                                        className={"input"}
                                        data-cy={'changeCode'}
                                        placeholder={t('loc.entry.code.place')}
                                        onChange={e => setEntranceCode(e.target.value)}
                                    />
                                )}
                            </Col>
                        </div>

                        <div className={"radio-item col"}>
                            <Radio
                                value={EEntranceOption.GUARD}
                                data-cy={'radioGUARD'}
                                className={'body2'}
                            >
                                {t('GUARD.call')}
                            </Radio>
                            {isNight && <div className={'small label black45'} data-cy={'radioGate'}>
                                {t('entrance.guard.label')}
                            </div>}
                        </div>

                        <Radio value={EEntranceOption.FREE} data-cy={'radioFree'}
                               className={'body2 radio-item'}>
                            {t('FREE')}
                        </Radio>
                    </Radio.Group>
                </div>
            </div>
        </Col>
    )
}

export default EntranceForm
